/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ParcelV { 
    accounting_price?: number;
    cena?: number;
    cena_popis?: string;
    cisl_kod?: number;
    cisl_nazev?: string;
    ctverec?: string;
    drupoz_kod?: number;
    drupoz_kod_man?: number;
    drupoz_nazev?: string;
    end_date?: string;
    id?: number;
    id_fb?: number;
    juristic_type_1?: boolean;
    juristic_type_3?: boolean;
    juristic_type_4?: boolean;
    juristic_type_5?: boolean;
    juristic_type_6?: boolean;
    katuze_kod?: number;
    katuze_kod_puv?: number;
    katuze_nazev?: string;
    katuze_nazev_puv?: string;
    kraj_kod?: number;
    kraj_nazev?: string;
    lv?: number;
    maplis?: string;
    nazev_ze?: string;
    nebonitovana_vymera?: number;
    obec_kod?: number;
    obec_nazev?: string;
    odkaz?: string;
    okres_kod?: number;
    okres_nazev?: string;
    par_id?: number;
    par_type?: string;
    parcis?: string;
    parcis_dil?: number;
    parcis_kmen?: number;
    parcis_pod?: number;
    pronajata_vymera?: number;
    prumerna_cena?: number;
    start_date?: string;
    subj_adresa?: string;
    subj_ico?: string;
    subj_nazev?: string;
    tax?: number;
    tax_payer?: number;
    tax_tenant?: boolean;
    type?: number;
    type_valid?: number;
    v_nasem_pb?: number;
    vymera?: number;
    vymera_doplneni?: number;
    ze_kod?: number | null;
    zkodfb?: string;
    zpurvy_kod?: number;
    zpurvy_nazev?: string;
    zpvypo_kod?: number;
    zpvypo_nazev?: string;
}

